import { getApiActionTypes } from '../../../../shared/store/storeHelpers';

export const fetchCategoryDetailsTypes = getApiActionTypes('ENTITY/FETCH_CATEGORY_DETAILS');
